import React from 'react';

import type { AgentManagedExtensionPlugin } from '../common/agentManagedExtensionPluginType';
import { pluginKey } from '../common/agentManagedExtensionPluginType';

import { closeConfig, openConfig, toggleConfig } from './editor-commands/configure-popup';
import { createPlugin } from './pm-plugins/main';
import { AgentManagedExtensionConfigurePopup } from './ui/AgentManagedExtensionConfigurePopup';

/**
 * Slim plugin entry-point for the agent-managed extension. Identity,
 * quick-insert, contextual toolbar and body renderer all live on the
 * manifest (see `getAgentManagedExtensionManifest`). This plugin owns
 * only the cross-cutting concerns that don't fit the manifest pattern:
 * schema registration, configure-popup state, the auto-open-on-insert
 * `view`, the Customize-button DOM event bridge, and the editor
 * commands surfaced via `extensionAPI`.
 */
export const agentManagedExtensionPlugin: AgentManagedExtensionPlugin = ({ api }) => {
	return {
		name: 'agentManagedExtension',

		pmPlugins() {
			return [
				{
					name: 'agentManagedExtension',
					plugin: ({ nodeViewPortalProviderAPI }) =>
						createPlugin({ nodeViewPortalProviderAPI }),
				},
			];
		},

		actions: {
			openConfig: () => {
				api?.core?.actions.execute(openConfig());
			},
			closeConfig: () => {
				api?.core?.actions.execute(closeConfig());
			},
			toggleConfig: () => {
				api?.core?.actions.execute(toggleConfig());
			},
			// TODO: CCINT-7834 - expose an `updateAgentManagedObject` action
		},

		contentComponent({ editorView, popupsMountPoint }) {
			if (!editorView) {
				return null;
			}
			return (
				<AgentManagedExtensionConfigurePopup
					api={api}
					editorView={editorView}
					mountPoint={popupsMountPoint}
				/>
			);
		},

		getSharedState(editorState) {
			if (!editorState) {
				return undefined;
			}
			return pluginKey.getState(editorState) ?? undefined;
		},
	};
};
